interface SearchBoxProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

export function SearchBox({ value, onChange, onSubmit }: SearchBoxProps) {
  return (
    <div class="db-search">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        type="text"
        placeholder="Search all content..."
        value={value}
        onInput={(e) => onChange((e.target as HTMLInputElement).value)}
        onKeyDown={(e) => { if (e.key === 'Enter') onSubmit(); }}
      />
      <span class="db-search-shortcut">⌘K</span>
    </div>
  );
}
